import { Product } from "@~/types/types";

export const isM2MFabricProduct = (product: Product) => {
  return (
    product?.configurationRequirements?.type.some(
      (v) => v === "MadeToMeasureCurtain" || v === "MadeToMeasureRomanBlind",
    ) || false
  );
};
